import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { askQuestionUrl } from "./questionHelpers";
import "./questions.css";

export default function Heading() {
  const { t } = useTranslation();
  return (
    <section className="avc-page-hero">
      <div className="container avc-page-hero__inner">
        <span className="avc-eyebrow">
          <i className="far fa-comments" aria-hidden="true"></i>
          {t("qa_eyebrow")}
        </span>
        <h1 className="avc-page-hero__title">{t("LegalAdvice")}</h1>
        <p className="avc-page-hero__lead">{t("Legal_advice_description")}</p>
        <Link to={askQuestionUrl()} className="avc-btn avc-btn--gold avc-qa-hero__cta">
          <i className="far fa-edit" aria-hidden="true"></i>
          {t("qa_ask")}
        </Link>
      </div>
    </section>
  );
}
